export default __webpack_public_path__ + "static/media/O-077.6faf00e8.png";